import { EmptyState } from '@/components/custom/empty-state';
import { Loader } from '@/components/custom/loader';
import { LessonMetricsCoursCard } from '@/app/screens/LmsStudent/LessonMetrics/lesson-metrics-course-card';
import { useTranslation } from 'react-i18next';
import { useClient } from 'jsonapi-react';
import moment from 'moment';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import Modal from 'src/app/components/Modal';
import useAuthorityLevel from '@/app/hooks/useAuthorityLevel';
import { Widget, WidgetBody, WidgetHeader, WidgetTitle } from '@/components/custom/widget';

export default function ModuleResultWidget(props) {
  const { userMetrics, userId } = props;
  const { t } = useTranslation();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disableNotifications, setDisableNotifications] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState();
  const [showModal, setShowModal] = useState(false);
  const [detailedCourse, setDetailedCourse] = useState();
  const client = useClient();
  const authorityLevel = useAuthorityLevel();
  const journey = true;

  const getCourses = async () => {
    setLoading(true);
    const url = authorityLevel === 'student' ? '/courses?detailed=true' : `/courses?user_id=${userId}&detailed=true`;

    const { data, error } = await client.fetch(url);
    if (error) {
      toast.error('Erro ao carregar cursos');
    } else {
      setCourses(data);
    }
    setLoading(false);
    setDisableNotifications(true);
  };

  useEffect(() => {
    getCourses();
  }, []);

  const getDetailedCourse = async () => {
    setLoading(true);
    const { data, error } = await client.fetch(`/courses/${selectedCourse.id}?user_id=${userId}&detailed=true`);
    if (error) {
      toast.error('Erro ao buscar curso');
    } else {
      setDetailedCourse(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (selectedCourse) {
      getDetailedCourse();
    }
  }, [selectedCourse]);

  return (
    <Widget>
      <WidgetHeader>
        <WidgetTitle className="mb-2">{t('journey.monitoringCoursesTitle')}</WidgetTitle>
      </WidgetHeader>

      {!loading && courses.length === 0 && <EmptyState type="data" />}

      <WidgetBody>
        <div
          className="tab__cards"
          style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 500px), 1fr))' }}
        >
          {loading && <Loader />}

          {courses &&
            courses?.map(course => {
              return (
                <LessonMetricsCoursCard
                  setShowModal={setShowModal}
                  journey={journey}
                  course={course}
                  key={course.id}
                  setSelectedCourse={setSelectedCourse}
                />
              );
            })}
        </div>
      </WidgetBody>

      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        contentClassName="modal__content--md"
      >
        <WidgetTitle className="mb-6">Acompanhamento dos módulos</WidgetTitle>

        <div className="tab__cards">
          {loading ? (
            <Loader />
          ) : (
            detailedCourse?.['learning-systems'].length === 0 && (
              <EmptyState
                type="data"
                text="Nenhum módulo encontrado para este curso"
              />
            )
          )}
          {!loading &&
            detailedCourse?.['learning-systems'].length > 0 &&
            detailedCourse?.['learning-systems'].map(item => {
              return (
                <div
                  className="card"
                  key={item.id}
                >
                  <div className="card__header">
                    <h3
                      className="card__title"
                      title={item.title}
                    >
                      {item.title}
                    </h3>
                    <p className="card__subtitle">{item.last_user_access ? `${t('journey.accessedIn')} ${moment(item.last_user_access).format(t('datesForm.formatDate'))}` : ''}</p>
                  </div>
                  <div className="card__body">
                    <div className="card__progress">
                      <div className="card__progress-container">
                        <div
                          className="card__progress-bar"
                          role="progressbar"
                          style={{
                            width: `${!isNaN(item.progress) ? Math.floor(item.progress) : 0}%`
                          }}
                          aria-valuenow={!isNaN(item.progress) ? Math.floor(item.progress) : 0}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        />
                      </div>
                      <div className="card__progress-text">{!isNaN(item.progress) ? Math.floor(item.progress) : 0}%</div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </Modal>
    </Widget>
  );
}
